module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAAAO0lEQVQokWP8DwQMJAAmUhSPaiAWsKALFNdPx1DU25iJ2wZkSWx8hv84QFHdNKzijKNJY8A1/P37jwEAkcM/XI7L+F0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xstb1-1.png
// module id = 419
// module chunks = 0